module.exports = __webpack_public_path__ + "f712c4311abe8123a58c11c4fb5d6e14.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-lines-brown-s.png
// module id = 1991
// module chunks = 0